import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import fieldPropTypes from "./field-prop-types";
import { fieldValidation } from "../utils/field-validation";
import ValidationMessage from "../theme/default/validation-message";

/* eslint-disable no-useless-escape */
const ISO_DATE_REGEX =
  /(\d{4}-\d{2}-\d{2}T\d{2}\:\d{2}\:\d{2})([-+]\d{2}\:\d{2})/;

const FormCalendarPickerSlots = ({ field, appData, components }) => {
  const fieldRef = useRef(null);

  const {
    name,
    type,
    data: { start_date, end_date, time_slots }
  } = field;
  const {
    values,
    handleChange,
    resetFieldValidation,
    isPulse,
    isEnhancedRedesign
  } = appData;
  const { DatePicker, TimeSlotPicker, Label } = components;

  const minDate = moment(start_date, "YYYY-MM-DD").toDate();
  const maxDate = moment(end_date, "YYYY-MM-DD").toDate();

  const [date, setDate] = useState(
    values[name] ? moment(values[name], "YYYY-MM-DD").toDate() : minDate
  );

  useEffect(() => {
    fieldValidation[type].update(field, appData, { fieldRef });
  });

  const timeSlot =
    date &&
    time_slots.find(
      timeSlotItem => timeSlotItem.date === moment(date).format("YYYY-MM-DD")
    );
  const includeDates = time_slots.map(timeSlotItem =>
    moment(timeSlotItem.date, "YYYY-MM-DD").toDate()
  );

  const invalid =
    appData.fieldValidation[name] && !appData.fieldValidation[name].isValid;
  const { errorMessage } = appData.fieldValidation[name] ?? {};

  // needed for highlighting the correct pill
  const dateSelected = moment
    .tz(values[name], appData.values.time_zone)
    .format();

  const { visit_date_with_asterix: calendarTitle } =
    appData.settings.translations;

  return (
    <div ref={fieldRef} className='field-wrapper-web-sdk'>
      <div className='react-datepicker-slots-wrapper-web-sdk'>
        <Label name={name} text={calendarTitle} />
        <DatePicker
          includeDates={includeDates}
          inline
          value={date}
          minDate={minDate}
          maxDate={maxDate}
          onChange={dateItem => {
            handleChange({ [name]: "" });
            setDate(dateItem);
            fieldRef.current.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            resetFieldValidation(name);
          }}
          invalid={!date && invalid}
          components={components}
          appData={appData}
        />
        {timeSlot && (
          <TimeSlotPicker
            title={moment(date).format("MMM D, YYYY")}
            times={timeSlot.times}
            selected={dateSelected}
            onSelect={dateItem => {
              resetFieldValidation(name);
              if (ISO_DATE_REGEX.test(dateItem)) {
                const matches = dateItem.match(ISO_DATE_REGEX);
                const dateNormalized = moment
                  .tz(matches[1], appData.values.time_zone)
                  .utc()
                  .format();
                handleChange({ [name]: dateNormalized });
              } else {
                handleChange({ [name]: dateItem });
              }
            }}
            components={components}
            invalid={invalid}
            usePulseStyles={isEnhancedRedesign || isPulse}
            appData={appData}
          />
        )}
      </div>
      <ValidationMessage isInvalid={invalid}>{errorMessage}</ValidationMessage>
    </div>
  );
};

FormCalendarPickerSlots.propTypes = fieldPropTypes;

export default FormCalendarPickerSlots;
